import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-950 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/15 text-3xl text-primary-400">
        <i className="ri-emotion-sad-line" aria-hidden="true"></i>
      </span>
      <p className="mt-6 font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl">页面走丢了</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-400">
        你访问的页面不存在或已被移除。下面是当前路径，回到首页继续发现好听的 MV 吧。
      </p>
      <p className="mt-2 rounded-md bg-background-900 px-3 py-1.5 font-mono text-xs text-foreground-500">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600">返回首页</Link>
        <Link to="/charts" className="rounded-md border border-background-700 px-5 py-2.5 text-sm text-foreground-300 hover:border-primary-500 hover:text-primary-400">去看排行榜</Link>
      </div>
    </div>
  );
}